/** Primary slogan. Verbatim everywhere it is typeset. */
export const MAKHE_SLOGAN = 'For students, by students.';

/** Accessible name for the purchased lockup image. */
export const MAKHE_LOCKUP_ALT =
  'Makhe. Your trusted neighbour. For students, by students.';
